<template>
  <div class="material-attention">
    <div class="title" v-if="attention">资料要求:</div>
    <ul class="items" v-if="attention">
      <li v-for="(item, index) in attentionArr" :key="index">
        <div class="content" v-text="item"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import uploadFileService from '../../services/upload-file-service';

export default {
  name: 'Attention',
  props: ['attention'],
  data() {
    return {
      attentionArr: uploadFileService.makeStringList(this.attention),
    };
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.material-attention {
  .title {
    font-size: 13px;
    line-height: 13px;
    color: @text-dark;
  }
  .items {
    margin-top: 10px;
    li {
      font-size: 13px;
      line-height: 22px;
      color: @text-sliver;
      display: flex;
      .dot {
        width: 12px;
      }
      .content {
        flex: 1;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/upload/attention.vue